import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { IconButton, Tooltip } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { sendEmail } from '../../queries/emailQueries';
import { summaryEditIcon } from '../../styles';
import { showToasterSuccess } from '../atoms/toast';

function ReminderEmail({ Container, data, overviewData }) {
  const { t } = useTranslation();
  const originURL = window.location.origin;
  const { mutate } = useMutation({
    mutationFn: sendEmail,
    onError: error => {
      showToasterSuccess(t('Email_failed_message'));
      console.error('Error sending reminder email:', error);
    },
    onSuccess: () => showToasterSuccess(t('Email_sent_message')),
  });
  const inProcess = Object.groupBy(
    data,
    item =>
      item.ActualStatus === '5' ||
      item.ActualStatus === null ||
      item.ActualStatus === ''
  );
  const emails = inProcess[true]
    ? inProcess[true].map(item => item.Email).filter(email => email)
    : '';

  function sendReminderEmails() {
    if (!emails || emails.length === 0) {
      return;
    }
    emails.forEach(email => {
      mutate({
        toAddress: email,
        fromAddress: 'PECR@carrier.com',
        Title: overviewData.Title || 'PECR Reminder',
        PecrId: overviewData.ID || '',
        loginUserEmail: email,
        type: 'assignEmail',
        toWhome: 'Reminder Email',
        URL: `${originURL}/MyToDo`,
      });
    });
  }
  return (
    <Container>
      <Tooltip
        title={`Send Reminder To ${emails ? emails.join(', ') : 'No Emails'}`}
      >
        <IconButton
          component="a"
          onClick={sendReminderEmails}
          sx={{
            color: '#1976d2',
            padding: '4px',
            minWidth: 'auto',
            minHeight: 'auto',
            display: 'inline-flex',
            alignItems: 'center',
            verticalAlign: 'middle',
            '&:hover': {
              color: '#115293',
              backgroundColor: 'rgba(25, 118, 210, 0.04)',
            },
          }}
          size="small"
          disabled={!emails}
        >
          <MailOutlineIcon
            sx={{
              ...summaryEditIcon,
              cursor: emails ? 'pointer' : 'not-allowed',
            }}
          />
        </IconButton>
      </Tooltip>
    </Container>
  );
}

ReminderEmail.propTypes = {
  Container: PropTypes.elementType.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      ActualStatus: PropTypes.string,
      Email: PropTypes.string,
    })
  ).isRequired,
};
export default ReminderEmail;
